// Estados de IMEI: mapa compartido entre el detalle del caso y el dashboard.
// Fuente única de verdad para colores/etiquetas (antes vivía duplicado en
// CasoDetalle.tsx) y helpers de búsqueda por IMEI.

export type EstadoImeiUI = "OK" | "REV" | "CRIT" | "CLI" | "PROVEEDOR";

export const ESTADO_IMEI_LABEL: Record<EstadoImeiUI, string> = {
  // No «OK»: la pastilla ya dice OK y salía «OK · OK» (muy visible desde que
  // los casos cerrados se pintan todos en verde, 2026-10-13).
  OK: "Sin pendientes",
  REV: "En revisión",
  CRIT: "Crítico",
  CLI: "Espera cliente",
  PROVEEDOR: "Con proveedor",
};

export const ESTADO_IMEI_PILL: Record<EstadoImeiUI, string> = {
  OK: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
  REV: "bg-amber-500/10 text-amber-300 border-amber-500/30",
  CRIT: "bg-red-500/10 text-red-300 border-red-500/30",
  CLI: "bg-sky-500/10 text-sky-300 border-sky-500/30",
  PROVEEDOR: "bg-orange-500/10 text-orange-300 border-orange-500/30",
};

// estado_manual puede venir null: se trata como "REV" (mismo criterio que el
// detalle del caso) para que un mismo IMEI se vea igual en todas las vistas.
export function estadoImeiUI(estadoManual: string | null | undefined): EstadoImeiUI {
  return (estadoManual ?? "REV") as EstadoImeiUI;
}

// Normaliza un texto de búsqueda de IMEI: minúsculas y solo alfanuméricos
// (quita espacios, guiones, puntos, etc.). Equivalente a normalizar_imei_query
// del backend, para que el filtro client-side y el server-side coincidan.
export function normalizarImeiQuery(q: string): string {
  return q.toLowerCase().replace(/[^a-z0-9]/g, "");
}

// True si el query normalizado aparece como substring del IMEI normalizado.
// Query vacío => true (sin filtro); el caller decide cuándo aplicar el match.
export function imeiCoincide(query: string, imei: string): boolean {
  const nq = normalizarImeiQuery(query);
  if (!nq) return true;
  return normalizarImeiQuery(imei).includes(nq);
}

// Parsea un texto de IMEIs (coma, espacios, tabs o saltos de línea) a una
// lista limpia y sin duplicados. Paste-friendly desde Excel/Sheets.
export function parseImeis(raw: string): string[] {
  const list = raw
    .split(/[,\s]+/)
    .map((s) => s.trim())
    .filter(Boolean);
  return Array.from(new Set(list));
}
